<template lang="pug">
.briq-form-element.briq-input(v-click-outside="closeMenu")
  label.input-label.type-bold.flex(v-if="label") {{ label }}
  .dropdown-flex
    .input-wrapper 
      button.anchor(@click='toggleShow' :style="`justify-content: ${itemLabel ? 'space-between' : 'flex-end'}`") {{ itemLabel ? itemLabel : placeholder }}
      div(v-if='showMenu' class='menu' )
        .menu-item(:class="item.id === activeItem ? `menu-item-active` : ``" v-for='item in this.items' @click='itemClicked(item)') {{ item.label }}
    span.clear-button(title='clear' data-clear @click='clearSelected')
      BriqIcon(name='icon-input-trash-icon')
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'BriqMenuDropdown',
  props: {
    label: String,
    placeholder: String,
    onClick: Function,
    items: Array,
    activeItem: String,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      showMenu: false,
      item: null
    }
  },
  computed: {
    itemLabel() {
      if (this.item) return this.item.label
      if (this.placeholder) return this.placeholder
      return null
    }
  },
  methods: {
    toggleShow() {
      this.showMenu = !this.showMenu
    },
    closeMenu() {
      this.showMenu = false
    },
    itemClicked(item) {
      this.toggleShow()
      this.onClick(item)
      this.item = item
    },
    clearSelected() {
      this.showMenu = false
      this.item = null
      this.onClick({id: '', label: ''})
    }
  },
  watch: {
    activeItem(newVal) {
      const newItem = this.items.find(item => item.id === newVal)
      if (newItem) this.item = newItem
      if (!newItem) this.item = null
    }
  },
  created() {
    const active = this.items.find(item => item.id === this.activeItem)
      if (active) this.item = active
  }
}
</script>

<style scoped lang="stylus">

.dropdown-flex 
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
.input-wrapper
  position: relative;
  width: 100%;
  border: solid 1px #ebebeb;
  border-radius: 3px;
  background: #fff;
  color: #2c333a;
  padding: 7px;
.anchor
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 16px;
  color: #798696;
  min-height: 24px;

  &:hover
    color #000e28
    cursor pointer

  &:after
		display inline-block
    width 0
    height 0
    margin-left .5em
    vertical-align .255em
    content ""
    border-top .3em solid
    border-right .28em solid transparent
    border-bottom 0
    border-left .28em solid transparent

.clear-button
  &:hover
    cursor: pointer;

.menu
	background-color #fff
	color #798696
	box-shadow 1px 1px 10px 1px #CCCCCC
	font-size 16px
	margin 8px 0 0 0
	padding 8px 0
	position absolute
	text-align left

.menu-item
	color #798696;
	padding 8px 16px
	transition color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out

.menu-item-active
  background-color #EFF3F7
  cursor pointer

.menu-item:hover
  background-color #EFF3F7
  cursor pointer
</style>
